var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgressOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-997.85-167.53H-162.2a3.69,3.69,0,0,1,3.69,3.69V206.06a0,0,0,0,1,0,0h-843a0,0,0,0,1,0,0V-163.83a3.69,3.69,0,0,1,3.69-3.69Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-717.06,205.16S-524,166.69-442.39,82.52c55.84-57.61,112.55-140.67,221-149.08S28.05,11.16,50.16,95.75c28.91,110.61,9.29,169.53,9.29,169.53Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "18.48 25.72 16.48 27.74 22.16 33.49 33.52 22 31.52 19.96 22.16 29.43 18.48 25.72",
    style: {
      fill: "#636c75"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.46,9.44h-8a5.72,5.72,0,0,0-10.84,0h-8a3.25,3.25,0,0,0-.77.08,3.77,3.77,0,0,0-1.94,1.07,3.94,3.94,0,0,0-1.14,2.74V40.56a3.94,3.94,0,0,0,1.14,2.76,3.77,3.77,0,0,0,1.94,1.07,4.81,4.81,0,0,0,.77.06H38.46a3.88,3.88,0,0,0,3.85-3.89V13.33A3.88,3.88,0,0,0,38.46,9.44ZM25,9a1.46,1.46,0,1,1-1.44,1.46A1.46,1.46,0,0,1,25,9ZM38.46,40.56H11.54V13.33H38.46Z",
    style: {
      fill: "#636c75"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressOutlinedIcon);
export default __webpack_public_path__ + "static/media/progress_outlined_icon.3eb059a791e2e7fcbd350582add5eee4.svg";
export { ForwardRef as ReactComponent };